export const QACOPILOT_WIDGET = false;
export const BROWSER_BRIDGE = false;
